module.exports = __webpack_public_path__ + "static/img/medal1.8fbb008.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/6/medal1.png
// module id = kiXT
// module chunks = 1